module.exports = __webpack_public_path__ + "img/customerportfolio.3f283ca0.png";